document.addEventListener('DOMContentLoaded', function() {
    let container_images = document.querySelectorAll('.card-product');
    container_images.forEach(function(container_image) {
        let id = container_image.getAttribute('id');

        let slider = tns({
            container: `#${id} .container-image-slider`,
            items: 1,
            slideBy: 1,
            autoHeight: false,
            controlsContainer: `#${id} .container-arrows`,
            autoplay: false,
            loop: false,
            nav: true,
            mouseDrag: true,
            navPosition: 'bottom',
        });
    });
});